import { AxiosPromise, AxiosStatic } from "axios";
import {
  TMultiDaySchedule,
  TNotificationsToSchedule,
  TProperties,
  TSimpleMessage,
} from "../../types";
import scheduleNotifications from "../../requests/scheduleNotifications";

export const createNotificationsList = (
  templateId: number,
  days: number[],
  properties?: TProperties
): TNotificationsToSchedule[] =>
  days.map((day) => {
    const today = new Date();
    today.setDate(today.getDate() + day);

    return {
      templateId,
      properties,
      dueAt: today.toISOString(),
    };
  });

/**
 * The multiDaySchedule is a helper function to help with situations when we need to
 * schedule the same notification for a series of days. The most notable example
 * in the platform is the KYC reminder, where we want to remind the user in 2, 5, and 10 days.
 *
 * This function works by passing the notification payload and a list of days to add.
 * So, for the example above, we would provide an array [2, 5, 10].
 * It will call the scheduleNotifications for you.
 *
 * multiDaySchedule({
 *   authUserId: 47926,
 *   namespace: "default",
 *   templateId: 2,
 *   properties: {
 *     docs: "yes, baby!",
 *   },
 *   days: [2, 5, 10],
 * });
 *
 */
const multiDaySchedule =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async ({
    authUserId,
    namespace,
    templateId,
    properties,
    days,
  }: TMultiDaySchedule): AxiosPromise<TSimpleMessage> => {
    const notifications = createNotificationsList(templateId, days, properties);
    const request = scheduleNotifications(serverURL, appAxios, token);

    return await request({
      authUserId,
      namespace,
      notifications,
    });
  };

export default multiDaySchedule;
